module.exports = __webpack_public_path__ + "static/img/gongshijianjie.419445ee.png";